<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/partiels/Navbar";
import Footer from "@/components/partiels/Footer";

export default {
  components: {
    Navbar,
    Footer
  }
};
</script>

